import type { CatalogueAsset } from '../services/catalogueActifsService';
import CatalogueActifCard from './CatalogueActifCard';

type ViewMode = 'enfant' | 'parent';

interface CatalogueActifsSectionProps {
  groupName: string;
  assets: CatalogueAsset[];
  selectedAssetId: string | null;
  highlightedAssetIds: Set<string>;
  viewMode: ViewMode;
  onAssetClick: (assetId: string) => void;
}

export default function CatalogueActifsSection({
  groupName,
  assets,
  selectedAssetId,
  highlightedAssetIds,
  viewMode,
  onAssetClick,
}: CatalogueActifsSectionProps) {
  if (assets.length === 0) return null;

  return (
    <section className="mb-2 rounded-lg border border-slate-200/80 bg-white/80 p-2 shadow-sm backdrop-blur-sm">
      <div className="mb-1.5 flex items-center gap-2">
        <div className="h-px flex-1 bg-slate-200" />
        <h2 className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">
          {groupName}
        </h2>
        <div className="h-px flex-1 bg-slate-200" />
      </div>

      <div className="flex flex-wrap gap-1.5">
        {assets.map((asset) => (
          <CatalogueActifCard
            key={asset.id}
            asset={asset}
            isSelected={selectedAssetId === asset.id}
            isHighlighted={highlightedAssetIds.has(asset.id)}
            viewMode={viewMode}
            onClick={() => onAssetClick(asset.id)}
          />
        ))}
      </div>
    </section>
  );
}
